import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

const LatestArticles: React.FC = () => {
  const latestArticles = articles.slice(0, 6);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              最新福利攻略
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              深度省钱攻略，让每一分钱都花得值
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <article key={article.id}>
              <Link
                to={`/article/${article.slug}`}
                className="group block bg-white rounded-xl border border-background-200 hover:border-primary-200 hover:shadow-md transition-all duration-300 overflow-hidden cursor-pointer h-full"
              >
                <div className="relative w-full h-52 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute bottom-3 left-3">
                    <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-medium rounded-full whitespace-nowrap">
                      {article.categoryName}
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 mb-4 line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-time-line"></i>
                      </span>
                      {article.readTime}
                    </span>
                    <span>{article.publishedAt}</span>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LatestArticles;